import React from "react";
import styles from "./Geschichte.module.css";
import geschichte from './assets/11062b_3acc413de3044ad3bef273e7fc2b0661~mv2.avif';

const Geschichte = () => {

    return(
        <>

        <div
            className={styles.hero}
            style={{ backgroundImage: `url(${geschichte})` }}
        />

        <main className="wrapper">
            <section className="wrapperContent">
                <div className={styles.text}>
                    <h1>DIE SCHULGESCHICHTE </h1>
                    <p>
                        Die Geschichte der IKS – Interkulturelle Schule Rhein-Main ist eine beeindruckende Reise durch 60
                        Jahre voller Wandel und Fortschritt. Es ist eine Geschichte, die eng mit der Entwicklung der
                        Gesellschaft und den Veränderungen in der Bildungslandschaft verbunden ist. Eine Geschichte, die uns
                        zeigt, wie wichtig es ist, mit der Zeit zu gehen und sich den Herausforderungen der Zukunft zu
                        stellen.
                    </p>
                </div>

                <div className={styles.text}>
                    <h2>Die Gründung der "Handelsschule Hierse" als Wegbereiterin der Modernisierung und Bildung in
                        Deutschland (1954 - 1991)
                    </h2>
                    <p>
                        Im Jahr 1954, als Walter Hierse die "Handelsschule Hierse" gründete, war Deutschland gerade dabei,
                        sich von den Schrecken des Zweiten Weltkriegs zu erholen. Es war eine Zeit des Aufbruchs und der
                        Hoffnung auf eine bessere Zukunft. Die Gründung einer Handelsschule in Frankfurt war ein wichtiger
                        Schritt in Richtung Modernisierung und Bildung. Die Schule bot jungen Menschen nach der Volksschule
                        die Möglichkeit, eine qualifizierte Ausbildung im Bereich Wirtschaft und Verwaltung zu erhalten und
                        sich auf eine erfolgreiche Karriere vorzubereiten.
                    </p>
                </div>
                <div className={styles.text}>
                    <h2>Weiterentwicklung der Schule unter der Leitung von Herrn Günter Koch und Einführung neuer
                        Bildungsangebote (1991 - 2011)</h2>
                    <p>
                        Im Jahr 1991, nach 37 Jahren erfolgreicher Arbeit, übernahm der "Gemeinnützige Schulverein e. V."
                        die Handelsschule Hierse. Unter der Leitung von Herrn Günter Koch, einem erfahrenen Diplom
                        Handelslehrer, entwickelte sich die Schule weiter. Neue Zweige wie die Fachoberschule mit dem
                        Schwerpunkt Wirtschaft und die zweijährige Höhere Berufsfachschule (Assistentenklassen) wurden
                        eingeführt, um den Bedürfnissen der Schüler gerecht zu werden und ihnen eine breitere Palette an
                        Bildungsmöglichkeiten zu bieten.
                    </p>
                </div>

                <div className={styles.text}>
                    <h2>Die Fusion mit der EAE und Gründung der IKS - Interkulturelle Schule Rhein-Main als wichtiger
                        Schritt für die Zukunft der Schule (2011)
                    </h2>
                    <p>
                        Im Jahr 2011 fusionierte der Gemeinnützige Schulverein e. V. mit der European School of Economics
                        gGmbH. Daraus entstand die IKS - Interkulturelle Schule Rhein-Main. Diese Fusion war ein wichtiger
                        Schritt für die Schule, da sie neue Impulse für ihre Entwicklung brachte. Die Schule öffnete sich
                        für neue kulturelle Perspektiven und Ideen für die Zukunft. Mit dem Umzug zum neuen Standort im
                        Stadtteil Frankfurter Berg im Jahr 2012 begann eine neue Ära, die leider ohne den verstorbenen
                        Schulleiter Koch begann. Doch seine partnerschaftliche Kultur und sein Erbe leben weiter. Die Schule
                        ist entschlossen, sie zu bewahren und weiterzuentwickeln.
                    </p>
                </div>

                <div className={styles.text}>
                    <h2>Eröffnung einer Grundschule an der IKS-Rhein-Main als neuer Höhepunkt in der Geschichte der Schule
                        und wichtiger Anlaufpunkt für Bildung und Integration sowie Weiterentwicklung zur IGS</h2>
                    <p>Mit der Eröffnung der IKS-Grundschule zu Beginn des Schuljahres 2013/14 öffnete sich die Schule. Sie
                        erweiterte sich in den Allgemeinbildenden Bereich und stellte sich damit den Anforderungen der Stadt
                        Frankfurt am Main, mehr Bildungsgerechtigkeit für Kinder mit unterschiedlichen Familiengeschichten,
                        anderer Religionen und Kulturen zu schaffen. Mit Beginn des Schuljahres 2017/2018 wurde diese
                        Grundstufe durch Organisationsänderung und Erweiterung zu einer Integrierten Gesamtschule mit
                        Grundstufe, die die Jahrgänge 1 bis 10 umfasst. An dieser Schule können alle in der zehnjährigen
                        Pflichtschulzeit möglichen Schulabschlüsse erworben werden. Damit schafft die Schule die
                        Anschlussfähigkeit für weitere schulische Bildung und für Beruf. Junge und alte Schüler lernen nun
                        im gleichen Haus, und die Schule bleibt ein wichtiger Anlaufpunkt für Bildung und Integration. Die
                        IKS - Interkulturelle Schule Rhein-Main hat eine beeindruckende Geschichte hinter sich und eine noch
                        vielversprechendere Zukunft vor sich.</p>
                </div>

                <div className={styles.text}>
                    <h2>Heute</h2>
                    <p>Die IKS Rhein-Main ist heute im beruflichen Bereich eine staatlich anerkannte Ersatzschule in freier
                        Trägerschaft. Die IGS mit Grundstufe ist eine staatlich genehmigte Ersatzschule. Die staatliche
                        Anerkennung ist nach Abschluss der Aufbauphase beim Land Hessen beantragt. Die IKS arbeitet nach dem
                        Curricula der öffentlichen Schulen.</p>
                </div>

            </section>

        </main>
            </>

    )
}
export default Geschichte;
